import React from 'react';

import { StopCircleIcon, PlayCircleIcon } from '@vlabs/icons';
import { Control, ButtonScrimGroup } from '@vlabs/uikit';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import st from './SharedCell.module.sass';

export function TelegramNotificationStatusButton({ value: { enable, onClick } }) {
  const { t } = useTranslation();

  const isDisabled = typeof enable !== 'boolean';

  if (isDisabled) {
    return (
      <div className={st.NotificationCellBody}>
        <span className={st.Status}>{t('недоступно')}</span>
      </div>
    );
  }

  return (
    <div className={cn(st.NotificationCellBody, { [st.NotificationCellBody_enable]: !isDisabled })}>
      <span className={cn(st.Status, { [st.Status_active]: enable === true })}>
        {enable ? t('кнопка.включено') : t('кнопка.отключено')}
      </span>
      <ButtonScrimGroup size="small">
        <Control.IconButton
          data-testid="telegram"
          icon={enable ? <StopCircleIcon /> : <PlayCircleIcon />}
          kind={enable ? 'negative' : 'positive'}
          onClick={onClick}
          variant="dimmed"
        />
      </ButtonScrimGroup>
    </div>
  );
}

TelegramNotificationStatusButton.propTypes = {
  value: PropTypes.object.isRequired,
};
